module.exports = __webpack_public_path__ + "img/folder.d2be9cc5.svg";